'use strict'

import React from 'react';
import PriorityTable from './PriorityTable.jsx';
import Field from './Field3.jsx';

export default class Matrix extends React.Component {
  constructor(props) {
    super(props);
    this.state=this.loadState(props);
  }

  loadState(props) {
    var defaultCategory=undefined;
    if (props.categories!==undefined) {
      if (props.value.category!==undefined) {
        defaultCategory=props.categories.filter(category=>category.name===props.value.category)[0];
      }
      if (defaultCategory===undefined) {
        defaultCategory=props.categories[0];
      }
    }
    return {
      row: props.fields.filter(field=>field.matrixType==="row")[0],
      column: props.fields.filter(field=>field.matrixType==="column")[0],
      category: defaultCategory,
      value: props.value
    };
  }

  componentWillReceiveProps(props) {
    this.setState(this.loadState(props));
  }

  updateField(event) {
    let newValue=Object.assign({},this.state.value);
    if (this.state.category) {
      newValue[this.state.category.name][event.target.name]=event.target.value;
      newValue.category=this.state.category.name;
    }
    this.updateMatrixState(newValue);
  }

  updateMatrixState(newValue) {
    this.setState({value: newValue}, ()=>{
      let newEvent={
        target: {
          name: this.props.name,
          value: newValue
        }
      };
      if (this.props.onChange) {
        this.props.onChange(newEvent);
      }
    });
  }

  changeCategory(event) {
    this.setState({category:this.props.categories.filter(category=>category.name===event.target.value)[0]});
  }

  changePriority(event) {
    let newValue=Object.assign({},this.state.value);
    let category=this.state.category;
    let row=this.state.row;
    let column=this.state.column;
    newValue.category=category.name;
    if (newValue[category.name]===undefined) {
      newValue[category.name]={};
    }
    newValue[category.name][this.state.row.name]=event.target.value.row;
    newValue[category.name][this.state.column.name]=event.target.value.column;
    this.updateMatrixState(newValue);
  }

  render() {
    let row=this.state.row;
    let column=this.state.column;
    let tableLabels={
      row: this.state.row.title,
      column: this.state.column.title
    };
    var items=this.props.categories.map(category=>({
      row: this.state.value[category.name]!==undefined ? parseInt(this.state.value[category.name][row.name]) : undefined,
      column: this.state.value[category.name]!==undefined ? parseInt(this.state.value[category.name][column.name]) : undefined,
      no: this.props.value.no,
      title: category.title,
      style: category.name===this.state.category.name ? "" : "faded"
    }));
    return this.state.value.hide!==true ? (
      <div style={{display: "flex", flexWrap: "wrap", justifyContent: "space-between", width:"100%"}}>
        <div style={{textAlign: "center"}}>
          <PriorityTable onClick={this.changePriority.bind(this)} showId={true} preventDetails={true} {...this.props} labels={tableLabels} items={items} no={this.props.value.no}/>
        </div>
        <div className="field">
          {this.props.categories && this.props.value.hideCategories!==true? (
            <div style={{paddingBottom: 15}}>
              {this.props.categories.map(category=>(
                <div style={{paddingBottom: 5}} key={category.name}>
                  <input onChange={this.changeCategory.bind(this)} type="radio" name="matrixCategory" id={"category."+category.name} defaultChecked={category.name===this.state.category.name} value={category.name}/> <label htmlFor={"category."+category.name}>{category.title}</label>
                </div>
              ))}
            </div>
          ) : null}
          {this.props.fields.map((field,index)=>(
            <Field onChange={this.updateField.bind(this)} key={index} {...field} controlled={true} value={this.state.value[this.state.category.name]!==undefined ? this.state.value[this.state.category.name][field.name] : ""}/>
          ))}
        </div>
      </div>
    ) : null;
  }
}



// WEBPACK FOOTER //
// ./views/components/Matrix.jsx